/**
 * @fileoverview POST handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/campaigns/" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postDecisioningStudioAgentsAppGroupIdDsaIdCampaignsCacheKeys } from "./constants";
import type {
  PostDecisioningStudioAgentsAppGroupIdDsaIdCampaignsProps,
  PostDecisioningStudioAgentsAppGroupIdDsaIdCampaignsResult,
} from "./types";

export const postDecisioningStudioAgentsAppGroupIdDsaIdCampaigns = reactQueryMutationAdapter(
  postDecisioningStudioAgentsAppGroupIdDsaIdCampaignsCacheKeys,
  (
    props: PostDecisioningStudioAgentsAppGroupIdDsaIdCampaignsProps
  ): Promise<PostDecisioningStudioAgentsAppGroupIdDsaIdCampaignsResult> => {
    return fetch(
      `/decisioning_studio_agents/${props.appGroupId}/${props.dsaId}/campaigns/`,
      "POST",
      {
        api_triggered_campaign_from_email_variant: {
          campaign_id: props.campaignId,
          message_variation_id: props.messageVariationId,
        },
      },
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
